import React from "react";
import { Col, Tooltip } from "antd";
import _ from "lodash";

const TruncatedName = ({
  name,
  style,
  maxLength = 20, // Default max length is 20
  className,
  ...props
}) => {
  const truncateName = (name, maxLength) => {
    return _.truncate(name, { length: maxLength, omission: "..." });
  };

  return (
    <Col
      style={{ overflowX: "auto", ...style }}
      span={24}
      className={className}
      {...props}
    >
      <Tooltip title={name || "Name"}>
        <p className="text-md font-bold">
          {truncateName(name, maxLength) || "Name"}
        </p>
      </Tooltip>
    </Col>
  );
};

export default TruncatedName;
